<template>
  <div class="queue-row">
    <!-- Speed队列 -->
    <div class="queue-card speed-card">
      <div class="queue-left">
        <i class="fas fa-bolt"></i>
        <span>{{ $t('manga.queueCard.speedQueue') }}</span>
        <span class="queue-num speed-num">{{ speedCount }}</span>
        <span>{{ $t('manga.queueCard.people') }}</span>
      </div>
      <div class="queue-right">
        <span>{{ $t('manga.queueCard.speedDesc') }}</span>
      </div>
    </div>
    <!-- VIP队列 -->
    <div class="queue-card vip-card">
      <div class="queue-left">
        <i class="fas fa-crown"></i>
        <span>{{ $t('manga.queueCard.vipQueue') }}</span>
        <span class="queue-num vip-num">{{ vipCount }}</span>
        <span>{{ $t('manga.queueCard.people') }}</span>
      </div>
      <div class="queue-right">
        <span>{{ $t('manga.queueCard.vipDesc') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  speedCount: {
    type: Number,
    default: 0
  },
  vipCount: {
    type: Number,
    default: 0
  }
})
</script>

<style scoped>
.queue-row {
  display: flex;
  gap: 2rem;
}

.queue-card {
  flex: 1;
  background: rgba(30, 41, 59, 0.6);
  border: 1px solid rgba(94, 234, 212, 0.2);
  border-radius: 12px;
  padding: 1.2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.speed-card:hover {
  border-color: rgba(251, 191, 36, 0.4);
  box-shadow: 0 4px 20px rgba(251, 191, 36, 0.1);
}

.vip-card:hover {
  border-color: rgba(94, 234, 212, 0.3);
  box-shadow: 0 4px 20px rgba(94, 234, 212, 0.1);
}

.queue-left {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #cbd5e1;
}

.queue-left i {
  font-size: 1.2rem;
}

.speed-card .queue-left i {
  color: #fbbf24;
}

.vip-card .queue-left i {
  color: #fbbf24;
}

.queue-num {
  font-size: 1.8rem;
  font-weight: bold;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: pulse 2s infinite;
}

.speed-num {
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
  -webkit-background-clip: text;
  background-clip: text;
}

.vip-num {
  background: linear-gradient(90deg, #5eead4, #a78bfa);
  -webkit-background-clip: text;
  background-clip: text;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.queue-right {
  color: #94a3b8;
  font-size: 0.9rem;
}

@media (max-width: 700px) {
  .queue-row {
    flex-direction: column;
  }

  .queue-card {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .queue-left {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
